import * as React from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  Typography
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Navbar from '../../components/navbar.jsx';
import BillZappPlans from '../../components/billzappPlans.jsx';
import BillingMachineCard from '../../components/billingMachineCard.jsx';
import SiteFooter from '../../components/siteFooter.jsx';
import { BILLZAPP_BUNDLES } from '../../data/billzappPlans';

const defaultTheme = createTheme();

export default function ProductsPage() {
  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <Navbar />

      {/* Header */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #00bcd4 100%)',
          color: 'white',
          pt: { xs: 12, md: 15 }, // clears the fixed navbar
          pb: { xs: 6, md: 8 },
          textAlign: 'center'
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 3 }}>
            <Button
              variant="outlined"
              sx={{
                color: 'white',
                borderColor: 'white',
                '&:hover': {
                  borderColor: '#e1f5fe',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
              }}
              href="/"
            >
              ← Back to Home
            </Button>
          </Box>
          <Typography variant="h1" sx={{ fontSize: { xs: '2.5rem', md: '4rem' }, fontWeight: 800, mb: 2 }}>
            Products
          </Typography>
          <Typography variant="h5" sx={{ fontSize: { xs: '1.1rem', md: '1.5rem' }, opacity: 0.9 }}>
            Billing machines and BillZapp software for restaurants, cafes and food businesses
          </Typography>
        </Container>
      </Box>

      {/* Pocket Billing Machine With Software */}
      <Box sx={{ py: { xs: 8, md: 10 }, background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)' }}>
        <Container maxWidth="lg">
          <Box textAlign="center" sx={{ mb: 6 }}>
            <Typography variant="h2" fontWeight="bold" sx={{ mb: 3, fontSize: { xs: '2.2rem', md: '3rem' } }}>
              Pocket Billing Machine With Software
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ maxWidth: '650px', mx: 'auto' }}>
              Start billing on day one with a BillZapp receipt printer, 2 inch or 3 inch, and a
              year of BillZapp software. Pay for the printer once, then renew the software every year.
            </Typography>
          </Box>
          <Grid container spacing={{ xs: 3, md: 2, lg: 3 }} justifyContent="center">
            {BILLZAPP_BUNDLES.map((bundle) => (
              <Grid item xs={12} sm={6} md={3} key={bundle.slug}>
                <BillingMachineCard bundle={bundle} />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Subscriptions */}
      <Box id="subscriptions" sx={{ py: { xs: 8, md: 12 }, bgcolor: 'grey.50', scrollMarginTop: '80px' }}>
        <Container maxWidth="lg">
          <Box textAlign="center" sx={{ mb: 5 }}>
            <Typography variant="h2" fontWeight="bold" sx={{ mb: 3, fontSize: { xs: '2.2rem', md: '3rem' } }}>
              Software Subscriptions
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ maxWidth: '600px', mx: 'auto' }}>
              Already have a printer? Choose a BillZapp plan on its own.
            </Typography>
          </Box>
          <BillZappPlans />
        </Container>
      </Box>

      <SiteFooter />
    </ThemeProvider>
  );
}
